import React from 'react';
import TopSection from './sections/TopSection';
import MiddleSection from './sections/MiddleSection';
import BottomSection from './sections/BottomSection';
import BgImage from './component/bgImage'
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
 

function App() {
  return (
    <div >
      <div className="mainBodyStyle" >
        <TopSection />
        <BgImage />
        <MiddleSection />
        { 
          isMobile ? "" :     <BottomSection/>
        }
        
      </div>
    </div>
  );
}

export default App;
